import styled from 'styled-components';

interface FlexStyleProps {
    $display?: string;
    $order?: number;
    $shrink?: number;
    $wrap?: string;
    $basis?: string;
    $flow?: string;
    $flex?: string;
    $direction?: string;
    $alignItems?: string;
    $alignContent?: string;
    $justifyContent?: string;
    $position?: string;
    $width?: string;
}
export const FlexStyle = styled.div<FlexStyleProps>`
    display: ${({ $display }) => $display || 'flex'};
    ${({ $order }) => $order && `order: ${$order}`};
    ${({ $shrink }) => $shrink && `flex-shrink: ${$shrink}`};
    ${({ $wrap }) => $wrap && `flex-wrap: ${$wrap}`};
    ${({ $basis }) => $basis && `flex-basis: ${$basis}`};
    ${({ $flow }) => $flow && `flex-flow: ${$flow}`};
    ${({ $flex }) => $flex && `flex: ${$flex}`};
    ${({ $direction }) => $direction && `flex-direction: ${$direction}`};
    ${({ $alignItems }) => $alignItems && `align-items: ${$alignItems}`};
    ${({ $alignContent }) => $alignContent && `align-content: ${$alignContent}`};
    ${({ $justifyContent }) => $justifyContent && `justify-content: ${$justifyContent}`};
    ${({ $position }) => $position && `position: ${$position}`};
    ${({ $width }) => $width && `width: ${$width}`};
`;
